import React from "react";

export type ButtonProps = {
  id?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>, children?: string) => void;
};

export function Button({ id, className = "", children, onClick }: ButtonProps) {
  return (
    <button
      className={`text-brandcolor ${className}`}
      id={id}
      role="button"
      onClick={onClick}
    >
      {children}
    </button>
  );
}
